import { Box, Button, Grid, TextField, Typography } from '@mui/material'
import { IssueAttachments } from './IssueAttachments'
import { STATUS_OPTIONS } from './issues-constants'

export function IssueDetailPanel({
	issue,
	adminNotes,
	onAdminNotesChange,
	onSaveNotes,
	onStatusChange,
	getAttachmentUrl,
	savingNote,
}) {
	return (
		<Box sx={{ py: 2, px: 2, bgcolor: 'action.hover', borderRadius: 1 }}>
			<Grid container spacing={3}>
				<Grid item xs={12} md={8}>
					<Box mb={2}>
						<Typography variant="subtitle2" color="text.secondary" gutterBottom>
							Description
						</Typography>
						<Typography variant="body2" sx={{ whiteSpace: 'pre-wrap' }}>
							{issue.description || 'No description provided.'}
						</Typography>
					</Box>
					{issue.issue_attachments?.length > 0 && (
						<Box mb={2}>
							<Typography variant="subtitle2" color="text.secondary" gutterBottom>
								Attachments
							</Typography>
							<IssueAttachments
								attachments={issue.issue_attachments}
								getAttachmentUrl={getAttachmentUrl}
							/>
						</Box>
					)}
				</Grid>
				<Grid item xs={12} md={4}>
					<Box mb={2}>
						<Typography variant="subtitle2" color="text.secondary" gutterBottom>
							Status
						</Typography>
						<Box display="flex" flexWrap="wrap" gap={0.5}>
							{STATUS_OPTIONS.map((s) => (
								<Button
									key={s}
									size="small"
									variant={issue.status === s ? 'contained' : 'outlined'}
									onClick={() => onStatusChange(s)}
								>
									{s.replace('_', ' ')}
								</Button>
							))}
						</Box>
					</Box>
					<Box>
						<Typography variant="subtitle2" color="text.secondary" gutterBottom>
							Admin Notes (internal)
						</Typography>
						<TextField
							fullWidth
							multiline
							rows={4}
							value={adminNotes}
							onChange={(e) => onAdminNotesChange(e.target.value)}
							placeholder="Internal notes for triage…"
							size="small"
							sx={{ mb: 1 }}
						/>
						<Button
							size="small"
							variant="contained"
							onClick={onSaveNotes}
							disabled={savingNote}
						>
							{savingNote ? 'Saving…' : 'Save Notes'}
						</Button>
					</Box>
				</Grid>
			</Grid>
		</Box>
	)
}
